export default __webpack_public_path__ + "static/background-7b1923aeef6f069438b626824b2da631.jpg";